import {AddButton} from '../../../../../../../../component/add-button/add-button';
import {Locale} from '../../../../../../../../provider/locale/localization';

type PropsType = {
    isPrimary?: boolean;
    onClick: () => void;
};

export function AddAppstoreAccountButton(props: PropsType): JSX.Element {
    const {isPrimary, onClick} = props;

    return (
        <AddButton onClick={onClick} type={isPrimary ? 'primary' : 'default'}>
            <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__ADD_ACCOUNT" />
        </AddButton>
    );
}
